/** Legal document metadata — versioned, never computed at render time (spec §40). */

export const LEGAL_DOCUMENT_VERSION = 'preview-v1'

export const LEGAL_EFFECTIVE_DATE = '2026-03-01'

export const LEGAL_LAST_UPDATED = '2026-03-01'

/** Production legal entity fields — populate before commercial launch (spec §30). */
export const LEGAL_ENTITY_METADATA = {
  entityName: null as string | null,
  registrationNumber: null as string | null,
  registeredAddress: null as string | null,
  legalContactEmail: 'legal@vistoera.com',
  governingLaw: null as string | null,
} as const

export const MISSING_PRODUCTION_LEGAL_FIELDS = [
  'entityName',
  'registrationNumber',
  'registeredAddress',
  'governingLaw',
] as const
